import { FlexWorkerRelation } from 'ogp/hooks/queryHooks/flexWorkers/useGetFlexWorkerProfile';
import { LevelTableCellProps } from 'redesign';
import { formatFullName } from 'shared/utils/formatting';
import { WorkerEmploymentType } from '@types';
import { ShiftClaimant } from '../../claimants/claimant-table.types';

export type ShiftDetailBaseColumnDefinition = {
  flexWorkerImage: FlexWorkerPopup;
  flexWorkerFullName: FlexWorkerName;
};

export type ShiftDetailActions = ShiftClaimant;
export type CheckedInIndicator = {
  visible: boolean;
  dateTime: string;
};

export const defaultCheckedInIndicator: CheckedInIndicator = {
  visible: false,
  dateTime: '',
};

export type FlexWorkerPopup = {
  id: string;
  firstName: string;
  lastName: string;
  imageUrl?: string;
  relation: FlexWorkerRelation;
  isFlexWorker?: boolean;
  hasCandidateLevel?: boolean;
  isReplacement?: boolean;
  employmentType: WorkerEmploymentType | undefined;
  lenderCompanyName: string | null;
  includeCheckedInIndicator: CheckedInIndicator;
};
export type FlexWorkerName = ReturnType<typeof formatFullName>;

export type ShiftDetailTableBaseOptions = {
  onProfileClick: (id: string, relation: FlexWorkerRelation) => void;
  getRowActions: (candidateDetails: ShiftClaimant) => React.ReactNode[];
};

export type ShiftDetailCellBaseProps<T extends keyof ShiftDetailBaseColumnDefinition> =
  LevelTableCellProps<
    ShiftDetailBaseColumnDefinition,
    ShiftDetailBaseColumnDefinition[T],
    ShiftDetailTableBaseOptions
  >;

export type AvailabilityStates = 'Beschikbaar' | 'Voorwaardelijk' | 'Niet beschikbaar';
